import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LlmChoice } from '../models/responses/llm-choice';
import { environment } from '../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class LlmChoiceService {

  constructor(private httpClient:HttpClient) { }

  create(llmChoice:LlmChoice){
    return this.httpClient.post<LlmChoice> (`${environment.llmChoiceUrl}`,llmChoice);
  }

  update(llmChoice:LlmChoice){
    return this.httpClient.put<LlmChoice> (`${environment.llmChoiceUrl}`,llmChoice);
  }
  
  delete(id:number){
    return this.httpClient.delete<LlmChoice> (`${environment.llmChoiceUrl}/id`);
  }
}
